var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnDb = function SvgIcnDb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.60078C12.3137 6.60078 15 5.52626 15 4.20078C15 2.8753 12.3137 1.80078 9 1.80078C5.68629 1.80078 3 2.8753 3 4.20078C3 5.52626 5.68629 6.60078 9 6.60078Z",
    stroke: "currentcolor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4V8.8C3 9.43652 3.63214 10.047 4.75736 10.4971C5.88258 10.9471 7.4087 11.2 9 11.2C10.5913 11.2 12.1174 10.9471 13.2426 10.4971C14.3679 10.047 15 9.43652 15 8.8V4",
    stroke: "currentcolor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9V13.8C3 14.4365 3.63214 15.047 4.75736 15.4971C5.88258 15.9471 7.4087 16.2 9 16.2C10.5913 16.2 12.1174 15.9471 13.2426 15.4971C14.3679 15.047 15 14.4365 15 13.8V9",
    stroke: "currentcolor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnDb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_db.c7e5475b.svg";
export { ForwardRef as ReactComponent };